module.exports = __webpack_public_path__ + "static/media/primary-light.b52091a9.svg";